import BaseNodeModel from "../BaseNodeModel";
import { Constant } from '../../const';
export default class ModuleReferenceNodeModel extends BaseNodeModel {
    /**
     * Module Reference node model
     * @module ModuleReferenceNodeModel
     * @param {string} nodeName Node display name
     * @param {number} x Node x coordinate on canvas
     * @param {number} y Node y coordinate on canvas
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     * @param {string} id If non-null, use this ID as the node ID
     */
    constructor(nodeName = "UNTITLED_NODE", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);
        this.props.nodeTypeName = "Module Reference";
        this.props.colorClass = "blue";
        this.props.iconClass = "command";
        this.DEFAULT_COLOR_CLASS = "blue";
        this.applyProps(props);
    }
   getConfigViews() {
        var configView = []
        
        configView = [{ type: "Input", label: this.getPropLabel("module_reference"), key: "moduleReference",  hint:"E.g. app.name, mod.name" ,suggestion: "variable", valRules: { "noEmpty": true,"moduleReference":true } }]
        
        return [
            ...this.getConfigViewNameField(),
            ...[
                {
                    type: "Textarea",
                    label: this.getPropLabel("description"),
                    key: "description"
                    
                },
                {
                    type: "ItemList",
                    label: this.getPropLabel("inputs"),
                    key: "inputs", view: "argument"
                    
                },
                {
                    type: "ItemList",
                    label: this.getPropLabel("outputs"),
                    key: "outputs",
                    view: "return"
                    
                }
            ],

            ...configView,];
    }
}